export default "__VITE_ASSET__D$MGX8fu__"